var TalentIndex = function () {

    // var $menuButton;
    var $body, $talentBackgroundEls;
    var hideAllBackgroundsTimeout;

    function init () {
        if (!$('.talent-archive-content')) return false;
        $body = $('body');
        $talentBackgroundEls = $('.talent-background');
        registerEvents();
    }

    function showBackground() {
        clearTimeout(hideAllBackgroundsTimeout);
        $body.addClass('hover');
        $talentBackgroundEls.removeClass('prev');
        $talentBackgroundEls.filter('.show')
            .removeClass('show')
            .addClass('prev');
        $talentBackgroundEls
            .removeClass('show')
            .filter('#bkg-'+$(this).attr('id'))
            .addClass('show');
    }

    function hideAllBackgrounds() {
        hideAllBackgroundsTimeout = setTimeout(function() {
            $body.removeClass('hover');
        },1000);
    }


    function registerEvents () {
        $body.on('mouseenter touchstart', 'a.talent-link', function() {
            clearTimeout(hideAllBackgroundsTimeout);
        });
        $body.on('mouseenter touchstart', 'a.talent-link', $.debounce(100,showBackground));
        $body.on('mouseleave touchend', 'a.talent-link', hideAllBackgrounds);
    }

    return {
        init: init
    }

}();
